import Vue from 'vue';
import VueRouter from 'vue-router';
import { createWizard, redirectByFundStatus } from '@/views/meitav-dash/open-fund/open-fund-wizard';
import store from '@/store';
import AuthenticatedViews from '@/views/infra/AuthenticatedViews';
import * as LoginApi from '@/api/LoginApi';

import MeitavDash from '@/views/meitav-dash/MeitavDash';

Vue.use(VueRouter);

export default {
  path: '/',
  name: 'AuthenticatedViews',
  component: AuthenticatedViews,
  redirect: { name: 'Open Fund' },
  async beforeEnter(to, from, next) {
    if (await LoginApi.isLoggedIn()) {
      await store.dispatch('session/init');
      await next();
    } else {
      await next({ name: 'Beginnings' });
    }
  },
  children: [
    {
      path: '/meitav',
      name: 'Meitav Dash',
      component: MeitavDash,
      async beforeEnter(to, from, next) {
        /*
         * We do not want to redirect when accessing the `fund-status` page, otherwise we will get
         * into infinite loop;
         * For example, consider the case where the fund is submitted:
         *     /md/open-fund {fund submitted} --> /md/fund-status {fund submitted} --> /md/fund-status -> ...
         */
        if (to.path === '/meitav/fund-status') {
          await next();
          return;
        }

        await redirectByFundStatus(to, from, next);
      },
      children: [
        createWizard(),
        {
          path: 'congratulations',
          component: () => import(/* webpackChunkName: "Congratulations" */ '@/views/meitav-dash/open-fund/Congratulations'),
        },
        {
          path: 'welcome-back',
          component: () => import(/* webpackChunkName: "WelcomeBack" */ '@/views/meitav-dash/open-fund/WelcomeBack'),
        },
        {
          path: 'fund-status',
          name: 'Fund Status',
          component: () => import(/* webpackChunkName: "FundStatus" */ '@/views/meitav-dash/open-fund/FundStatus'),
        },
      ],
    },
  ],
};
